import * as React from 'react'
import { Modal } from 'react-bootstrap'
import Props from './props'
import * as SC from "./style"

class ModalView extends React.Component<Props> {
  public static defaultProps: Partial<Props> = {
    show: false,
    bsSize: 'large',
  }

  render() {
    return (
      <SC.StyledModalView>
      <Modal
        className={this.props.className}
        show={this.props.show}
        onHide={this.props.onHide}
        bsSize={this.props.bsSize}
        dialogClassName={this.props.dialogClassName}
      >
        {this.props.header && <Modal.Header>{this.props.header}</Modal.Header>}
        <Modal.Body>{this.props.content || this.props.children}</Modal.Body>
        {this.props.footer && <Modal.Footer>{this.props.footer}</Modal.Footer>}
      </Modal>
      </SC.StyledModalView>
    )
  }
}

export default ModalView



// WEBPACK FOOTER //
// ./src/presentations/views/ModalView/index.tsx